import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
var prefixClass = 'c-toast';
export default {
  props: {
    type: {
      type: String,
      default: 'loading'
    },
    message: {
      type: String
    },
    isShow: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 2000
    }
  },
  data: function data() {
    return {
      interval: 0,
      isClosed: false,
      // type: 'loading',
      styles: {
        top: '50%',
        left: '50%',
        marginLeft: ''
      }
    };
  },
  computed: {
    classes: function classes() {
      return "".concat(prefixClass, " ").concat(prefixClass, "-").concat(this.type || 'msg');
    },
    iconClass: function iconClass() {
      return {
        warning: 'iconfont-warning',
        success: 'iconfont-chenggong',
        fail: 'iconfont-shibai',
        error: 'iconfont-cry',
        msg: 'iconfont-warning'
      }[this.type];
    }
  },
  methods: {
    show: function show() {
      var _this = this;
      var $content = this.$el.querySelector('.toast-content');
      this.isClosed = false;
      // this.isShow = true;
      this.$nextTick(function () {
        var width = "".concat(-$content.clientWidth / 2, "px");
        var height = "".concat(-$content.clientHeight / 2, "px");
        _this.styles.left = '50%';
        _this.styles.top = '50%';
        _this.styles.marginLeft = width;
        _this.styles.marginTop = height;
      });
      if (this.duration) {
        this.closeMyself();
      }
    },
    destroyElement: function destroyElement() {
      this.$el.removeEventListener('transitionend', this.destroyElement);
      this.$destroy(true);
      if (this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
    },
    close: function close() {
      this.isClosed = true;
      // this.isShow = false;
      // this.$el.addEventListener('transitionend', this.destroyElement);
      this.destroyElement();
    },
    closeMyself: function closeMyself() {
      var _this2 = this;
      var timer = setTimeout(function () {
        if (_this2.isClosed) {
          return;
        }
        _this2.destroyElement();
        clearTimeout(timer);
      }, this.duration);
    }
  },
  mounted: function mounted() {},
  watch: {
    isShow: function isShow() {}
  }
};